import gql from 'graphql-tag';
import { DataProxy } from 'apollo-cache';
import { FetchResult } from 'apollo-link';
import { ADDRESS_FRAGMENT, RestAddressData } from '../fragments.rest';

export type UseAddressesQuery = {
  useAddresses: {
    __typename: 'RestAddress';
    data: RestAddressData[];
  };
};

export const USE_ADDRESSES_QUERY = gql`
  query UseAddressesQuery {
    useAddresses @rest(type: "RestAddress", endpoint: "user", path: "/addresses", method: "GET") {
      data @type(name: "RestAddressData") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;

export const updateAddressesCache = (cache: DataProxy, result: FetchResult, id?: string) => {
  if (result.errors) {
    return;
  }

  const data = cache.readQuery<UseAddressesQuery>({
    query: USE_ADDRESSES_QUERY
  });

  if (!data) {
    return;
  }

  const writeQuery = (addresses: RestAddressData[]) =>
    cache.writeQuery<UseAddressesQuery>({
      query: USE_ADDRESSES_QUERY,
      data: {
        ...data,
        useAddresses: {
          data: addresses,
          __typename: 'RestAddress'
        }
      }
    });

  const cachedAddresses = [...data.useAddresses.data];

  const createdAddress: RestAddressData | undefined = result.data?.createAddress?.data;
  if (createdAddress) {
    writeQuery([createdAddress, ...cachedAddresses]);
  } else if (result.data?.deleteAddress) {
    writeQuery(cachedAddresses.filter((address: RestAddressData) => address.id !== id));
  }
};
